import { render, staticRenderFns } from "./AccountHolder.vue?vue&type=template&id=3c79b874&scoped=true&"
import script from "./AccountHolder.vue?vue&type=script&lang=js&"
export * from "./AccountHolder.vue?vue&type=script&lang=js&"
import style0 from "./AccountHolder.vue?vue&type=style&index=0&id=3c79b874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79b874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
